module.exports = __webpack_public_path__ + "static/media/gold-chips.34f3ad5f.svg";